import './style.scss'

import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import icon from '../../../assets/image/icons/svg/icons/support.svg'
import { CONSTS } from '../../../config/objectConst'
import css from './SupportButton.module.scss'

export const SupportButton = () => (
	<Button
		as='a'
		className={css.root}
		href={CONSTS.HELP_URL}
		rel='noopener noreferrer'
		target='_blank'
		typography={typo.caption}
	>
		<img alt='Lifebuoy.' height={18} src={icon} width={18} />
		Help Center
	</Button>
)
